import { Quote, ShieldCheck } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { useLang } from "@/i18n/LanguageContext";

export const TestimonialsSection = () => {
  const { t } = useLang();
  const ts = t.testimonials;
  return (
    <section className="relative scroll-mt-24 py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid bg-grid-fade pointer-events-none" style={{ zIndex: 0 }} />
      <div
        className="glow-orb animate-glow pointer-events-none"
        style={{ zIndex: 0, width: 480, height: 320, top: -40, left: "50%", transform: "translateX(-50%)", background: "var(--blue)", opacity: 0.12 }}
      />
      <div className="relative z-10 mx-auto max-w-7xl px-5">
        <SectionHeading eyebrow={ts.eyebrow} title={ts.title} intro={ts.intro} testId="testimonials-heading" />

        <div className="scene-3d mt-14 grid md:grid-cols-3 gap-5" data-testid="testimonials-grid">
          {ts.items.map((it, i) => (
            <figure key={i} className="glass-card depth-card sheen rounded-3xl p-7 flex flex-col" data-testid={`testimonial-${i}`}>
              {it.subhead && (
                <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--blue-bright)]" data-testid={`testimonial-subhead-${i}`}>
                  {it.subhead}
                </div>
              )}
              {it.metric && (
                <div className="mt-3 font-mono text-sm leading-relaxed text-[var(--cyan)] font-semibold" data-testid={`testimonial-metric-${i}`}>
                  {it.metric}
                </div>
              )}
              <Quote size={22} className="mt-5 text-[var(--blue-bright)] opacity-70" />
              <blockquote className="mt-3 text-sm text-white/90 leading-relaxed flex-1">{it.quote}</blockquote>
              <figcaption className="mt-6 border-t border-[var(--line)] pt-4">
                <div className="font-display font-semibold text-white text-sm">{it.role}</div>
                <div className="font-mono text-[11px] text-[var(--muted-2)] mt-0.5">{it.company}</div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 text-xs text-[var(--muted-2)] font-mono" data-testid="testimonials-note">
          <ShieldCheck size={13} className="text-[var(--green)]" /> {ts.note}
        </div>
      </div>
    </section>
  );
};
